import { COLORS } from '../../constants';
import Icon, { iconNames } from './icon';

export const InfoListItem = ({ text, fill = COLORS.GREEN }) => {
    return (
        <div className="info-list-item">
            <Icon name={iconNames.checkboxFilled} size={20} fill={fill} />
            <div className="info-list-item__text">{text}</div>
        </div>
    );
};
